var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/require-default-props */
import React from 'react';
import { Checkbox as FlowbiteCheckbox, Label } from 'flowbite-react';
import { isString } from 'lodash';
import { Translate } from "../../../I18N";










const Checkbox = /*#__PURE__*/React.forwardRef(
  ({ name, onChange, className, disabled, checked, label }, ref) => /*#__PURE__*/
  _jsx("fieldset", { className: `flex flex-wrap gap-4 ${className}`, id: `radio_${name}` }, void 0, /*#__PURE__*/
  _jsx("div", { className: "flex items-center w-full gap-2 mr-4" }, void 0, /*#__PURE__*/
  React.createElement(FlowbiteCheckbox, {
    checked: checked,
    id: name,
    name: name,
    disabled: disabled || false,
    onChange: onChange,
    ref: ref }
  ), /*#__PURE__*/
  _jsx(Label, {
    htmlFor: name,
    className: `w-full text-sm font-medium text-gray-900 cursor-pointer ${disabled ? '!text-gray-300' : ''}` }, void 0,

  isString(label) ? /*#__PURE__*/_jsx(Translate, {}, void 0, label) : label
  )
  )
  )

);

export { Checkbox };